import { render, staticRenderFns } from "./PaymentRecordsDialog.vue?vue&type=template&id=7cd6fe48&scoped=true"
import script from "./PaymentRecordsDialog.vue?vue&type=script&lang=js"
export * from "./PaymentRecordsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6fe48",
  null
  
)

export default component.exports